"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useLocation = exports.LocationContext = exports.LocationProvider = exports.Location = void 0;

var _react = _interopRequireDefault(require("react"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _internal = require("./internal");

var LocationContext = (0, _internal.createNamedContext)('Location');
exports.LocationContext = LocationContext;

var LocationProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LocationProvider, _React$Component);

  var _super = (0, _createSuper2.default)(LocationProvider);

  function LocationProvider() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, LocationProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.state = {
      context: _this.getContext()
    };
    return _this;
  }

  (0, _createClass2.default)(LocationProvider, [{
    key: "getContext",
    value: function getContext() {
      var _this$props$location = this.props.location,
          pathname = _this$props$location.pathname,
          search = _this$props$location.search,
          hash = _this$props$location.hash;
      return {
        pathname: pathname,
        search: search,
        hash: hash
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _internal.gHistory.listen(function () {
        _this2.setState(function () {
          return {
            context: _this2.getContext()
          };
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var context = this.state.context;
      return /*#__PURE__*/_react.default.createElement(LocationContext.Provider, {
        value: context
      }, typeof children === 'function' ? children(context) : children || null);
    }
  }]);
  return LocationProvider;
}(_react.default.Component);

exports.LocationProvider = LocationProvider;
LocationProvider.defaultProps = {
  location: window.location
};

var Location = function Location(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(LocationContext.Consumer, null, function (context) {
    return context ? children(context) : /*#__PURE__*/_react.default.createElement(LocationProvider, null, children);
  });
};

exports.Location = Location;

var useLocation = function useLocation() {
  var location = _react.default.useContext(LocationContext);

  return location;
};

exports.useLocation = useLocation;